import {useMemo} from 'react';
import {useOnboardingRoadmap} from './useOnboardingRoadmap';
import {
  type FlattenedStep,
  OnboardingStepKeyEnum,
  type PmProviderKey,
  PMTOOLS_PROVIDER_ORDER,
  RISK_MITIGATION_SUBSTEPS,
  type RiskSubKey
} from '../types';

export function useOnboardingFlattenedTour() {
  const { steps } = useOnboardingRoadmap();

  const includedKeys = useMemo(() => steps.filter(s => s.include).map(s => s.key), [steps]);

  const flattened: FlattenedStep[] = useMemo(() => {
    const list: FlattenedStep[] = [];

    if (includedKeys.includes(OnboardingStepKeyEnum.RiskMitigation)) {
      for (const sub of RISK_MITIGATION_SUBSTEPS) {
        list.push({ key: OnboardingStepKeyEnum.RiskMitigation, riskSubKey: sub });
      }
    }

    for (const prov of PMTOOLS_PROVIDER_ORDER) {
      list.push({ key: OnboardingStepKeyEnum.PmTools, provider: prov as PmProviderKey });
    }
    if (includedKeys.includes(OnboardingStepKeyEnum.ImportUsers)) list.push({ key: OnboardingStepKeyEnum.ImportUsers });
    if (includedKeys.includes(OnboardingStepKeyEnum.ImportTeams)) list.push({ key: OnboardingStepKeyEnum.ImportTeams });
    if (includedKeys.includes(OnboardingStepKeyEnum.OrgSkills)) list.push({ key: OnboardingStepKeyEnum.OrgSkills });
    if (includedKeys.includes(OnboardingStepKeyEnum.AllocateSkills)) list.push({ key: OnboardingStepKeyEnum.AllocateSkills });
    if (includedKeys.includes(OnboardingStepKeyEnum.OrgHolidays)) list.push({ key: OnboardingStepKeyEnum.OrgHolidays });
    return list;
  }, [includedKeys]);

  const totalSteps = flattened.length;

  const getIndexForProvider = (provider: PmProviderKey): number => {
    return flattened.findIndex(item => item.key === OnboardingStepKeyEnum.PmTools && item.provider === provider);
  };

  const getIndexForStepKey = (key: OnboardingStepKeyEnum): number => {
    return flattened.findIndex(item => item.key === key);
  };

  const getIndexForRiskSubKey = (subKey: RiskSubKey): number => {
    return flattened.findIndex(item => item.key === OnboardingStepKeyEnum.RiskMitigation && item.riskSubKey === subKey);
  };

  return { flattened, totalSteps, getIndexForProvider, getIndexForStepKey, getIndexForRiskSubKey };
} 